<template>
  <div>
    <listmap-component v-if="panel.panel_widget_id === 9" :permissions="permissions"></listmap-component>
    <template v-if="sbObj">
      <projects v-if="panel.panel_widget_id === 16" :sbData="sbData"></projects>
    </template>
     <template v-if="sxObj">
      <projects v-if="panel.panel_widget_id === 19" :sbData="sxObj" :isSX="true"></projects>
    </template>
  </div>
</template>

<script>
import Projects from './SmartBuilderWidgets/Projects.vue';
import listmapComponent from './RegTrackerWidgets/ListMapCardComponent.vue';

export default {
  name: 'HorizontalCardComponent',
  components: {
    Projects,
    listmapComponent,
  },
  props: ['panel', 'sbData', 'permissions', 'sxData'],
  data() {
    return {
      sbObj: null,
      sxObj: null,
    };
  },
  computed: {
  },
  watch: {
    sbData() {
      if (this.sbData) {
        this.sbObj = this.sbData;
      }
    },
    sxData() {
      if (this.sxData) {
        this.sxObj = this.sxData;
      }
    },
  },
  methods: {
  },
  created() {
  },
};
</script>
<style scoped>

</style>
